// extracted by mini-css-extract-plugin
module.exports = {"shareBlock":"styles_shareBlock__uEFyO","shareBlockStatic":"styles_shareBlockStatic__qKjjW","shareIcon":"styles_shareIcon__YjTRB"};